<div class="upperSection">
  <div class="menuTitleWithExit">
    <div class="menuTitle" style="padding-top: 11px">
      <div class="title">Layers</div>
    </div>
    <div class="menuTitle exitMenu">
      <mat-icon class="closeIcon" svgIcon="panel.close" (click)="closePanel.emit()"></mat-icon>
    </div>
  </div>
  @if (enableFunctionalities) {
    <div class="treeControllers">
      <span (click)="menu.expandAll()" class="textButtonOnPanel">Expand All</span>
      <span class="buttonSeperator"></span>
      <span (click)="menu.collapseAll()" class="textButtonOnPanel">Collapse All</span>
    </div>
  }
</div>

<div class="middleSection layersMenu" [class.noContent]="layers.length === 0">
  @if (layers.length === 0) {
    <div class="noContentAvailable">No layer is available for this site</div>
  }
  <perfect-scrollbar [class.hiddenSection]="layers.length === 0">
    <ins-tree-menu #menu [tree]="layers" [nodeStyle]="{}" [checkboxOnPanel]="true"
      (propertyChanged)="layerPropertyChanged($event)" (hoveredNode)="hoveredLayer = $event" [hideEmptyGroupLayers]="false">
      <div leafHoverContent>
        @if (isPermEditLayer) {
          <mat-icon class="controlButton editLayerBtn" svgIcon="sites.edit" (click)="editLayer($event)" insTooltip [cfg]="{text: 'Edit', position: {H: 'hCenter', V:'vTop'}, type: 'info'}"></mat-icon>
        }
        @if (isAdmin) {
          <mat-icon class="controlButton editLayerBtn" svgIcon="copy" (click)="copyLayer($event)" insTooltip [cfg]="{text: 'Copy', position: {H: 'hCenter', V:'vTop'}, type: 'info'}"></mat-icon>
        }
        @if (isPermDeleteLayer) {
          <mat-icon class="controlButton deleteLayerBtn" svgIcon="app.delete" (click)="removeLayer($event)" insTooltip [cfg]="{text: 'Delete', position: {H: 'hCenter', V:'vTop'}, type: 'info'}"></mat-icon>
        }
      </div>
      @if (isPermEditLayer) {
        <mat-icon groupHoverContent class="controlButton editLayerBtn" svgIcon="sites.edit" (click)="editLayer($event)" insTooltip [cfg]="{text: 'Edit', position: {H: 'hCenter', V:'vTop'}, type: 'info'}"></mat-icon>
      }
      @if (isAdmin) {
        <mat-icon groupHoverContent class="controlButton editLayerBtn" svgIcon="copy" (click)="copyLayer($event)" insTooltip [cfg]="{text: 'Copy', position: {H: 'hCenter', V:'vTop'}, type: 'info'}"></mat-icon>
      }
      @if (isPermDeleteLayer) {
        <mat-icon groupHoverContent class="controlButton deleteLayerBtn" svgIcon="app.delete" (click)="removeLayer($event)" insTooltip [cfg]="{text: 'Delete', position: {H: 'hCenter', V:'vTop'}, type: 'info'}"></mat-icon>
      }
      <!-- <mat-icon *ngIf="isPermDeleteLayer" condGroupHoverContent class="controlButton deleteLayerBtn" svgIcon="app.delete" (click)="removeLayer($event)" insTooltip [cfg]="{text: 'Delete', position: {H: 'hCenter', V:'vTop'}, type: 'info'}"></mat-icon> -->
    </ins-tree-menu>
  </perfect-scrollbar>
</div>

<div class="lowerSection itemControllers alignCenter">
  @if (isPermCloneLayers && enableFunctionalities) {
    <div id="cloneLayers" class="textButtonOnPanel" (click)="cloneLayersDialog()">Clone Layers</div>
  }
  @if (isPermCloneLayers && enableFunctionalities) {
    <div class="buttonSeperator fontHeight"> </div>
  }
  @if (isPermDeleteAll && enableFunctionalities) {
    <div id="deleteAllLayers" class="textButtonOnPanel" (click)="deleteAllLayers()">Delete All</div>
  }
  @if (isPermDeleteAll && enableFunctionalities) {
    <div class="buttonSeperator fontHeight"> </div>
  }
  @if (isPermAddLayer && enableFunctionalities) {
    <div id="addLayer" class="textButtonOnPanel" (click)="AddLayer()">Add Layer</div>
  }
</div>
